/**
 * O que fazer quando o player reconecta e descobre o estado real do gatilho no servidor.
 *
 * <p><b>Por que existe.</b> O SSE é dispare-e-esqueça. Se o canal cair no instante em que o
 * servidor publica `trigger_fired` ou `trigger_deactivated`, o evento se perde e o player
 * NUNCA descobre — não há reenvio. Medido no player web do Renato em 2026-10-15: o token SSE
 * expirou (401), a conexão caiu, e a desativação publicada nessa janela não chegou. Como
 * CONTINUOUS não tem prazo por design, o gatilho ficou em loop por mais de uma hora.</p>
 *
 * <p>A saída não é ouvir melhor — é <b>perguntar</b>. Ao reconectar o player consulta o
 * servidor e se ajusta, nos dois sentidos: entrou um gatilho que ele não ouviu, ou acabou um
 * que ele não soube que acabou.</p>
 */
export type AcaoDeReconciliacao = 'disparar' | 'desativar' | 'nada';

export interface EstadoParaReconciliar {
  /** Id do gatilho em curso SEGUNDO O SERVIDOR; `null` = nenhum. */
  gatilhoNoServidor: number | null;
  /** Id do gatilho que o player acha que está tocando; `null` = nenhum. */
  gatilhoNoPlayer: number | null;
}

/**
 * @returns `disparar` quando o player perdeu um `trigger_fired` (ou está no gatilho errado),
 *          `desativar` quando perdeu um `trigger_deactivated`, `nada` quando já concordam.
 */
export function reconciliarGatilho({
  gatilhoNoServidor,
  gatilhoNoPlayer,
}: EstadoParaReconciliar): AcaoDeReconciliacao {
  if (gatilhoNoServidor === gatilhoNoPlayer) return 'nada';
  // O servidor é a fonte da verdade: ele decide quem dispara e quando acaba.
  if (gatilhoNoServidor === null) return 'desativar';
  return 'disparar';
}
